/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br>
  <div>
  <div class="formPosition">

  
<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
      <v-card style="margin:auto;border:1px solid #006699;" width="1200px">
        <v-card-title   style="margin:auto;background-color:#006699; color:white; ">
       <v-row>
            <v-col md="8">
              <span>Novo Fornecedor</span>
            </v-col>
            <v-col md="2">
              <v-btn color="white"  @click="$router.push('Visualizar-Fornecedor')"  >Consultar Fornecedores <v-icon>list_alt</v-icon></v-btn>
            </v-col>
             <v-col md="2">
                <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info
          </v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>
            </v-col>
          </v-row>
  </v-card-title>
         <v-alert
          v-model="alert"
          dismissible
          :type="alertType"
          border="left"
          :icon="iconAlert"
          transition="scale-transition"
          :style="colorAlert"
          elevation="2"
          colored-border
        >
        {{msgAlert}}
      </v-alert>
        <v-card-text>
          <v-container>
            <v-row>
               <v-col cols="12" sm="6" md="8">
                 <v-text-field v-model="editedItem.nome" :rules="ruleRequired" label="Nome Completo" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.nif" :rules="ruleRequired" label="NIF" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="6">
                <v-select
                    :items="tipoFornecedor"
                    item-text="descricao"
                    item-value="descricao"
                    v-model="editedItem.tipoFornecedor"
                    :rules="ruleRequired"
                    outlined
                    filled
                    label="Tipo de Fornecedor"
                ></v-select>
              </v-col>
               <v-col cols="12" sm="6" md="6">
                 <v-text-field v-model="editedItem.morada" :rules="ruleRequired"  label="Morada" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="6">
                 <v-text-field v-model="editedItem.telefone1" :rules="ruleRequired" label="Telefone 1" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="6">
                 <v-text-field v-model="editedItem.telefone2" label="Telefone 2" ></v-text-field>
               </v-col>
                <v-col cols="12" sm="6" md="6">
                 <v-text-field v-model="editedItem.email" :rules="ruleRequired" label="Email" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="6">
                 <v-text-field v-model="editedItem.Observacao" label="Observação" ></v-text-field>
               </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="color:white;" :disabled="!valid" color="green darken-1"   @click="Save()">Submeter</v-btn>
        </v-card-actions>
      </v-card>
  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    search: '',
    menuFab: null,
    menuExp: null,
    dataExpiracao: '',
    dataFabrico: '',
    valid: true,
    produtos: [],
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    editedIndex: -1,
    editedItem: {
      nome: '',
      nif: '',
      tipoFornecedor: '',
      morada: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },

    tipoFornecedor:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
  },

  methods: {
    async Save () {
      if (this.$refs.form.validate()) {
        let params =
          {
            pkFornecedor: 0,
            nome: this.editedItem.nome,
            nif: this.editedItem.nif,
            tipoFornecedor: this.editedItem.tipoFornecedor,
            morada: this.editedItem.morada,
            telefone1: this.editedItem.telefone1,
            telefone2: this.editedItem.telefone2,
            email: this.editedItem.email,
            observacao: this.editedItem.observacao
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/fornecedorInsertOrUpdate', params)
            .then(res => res.data)

          if (msg.affectedRows >= 1) {
            Swal.fire('Fornecedor registrado com sucesso.','','success')
            this.reset()
          }
        } catch (error) {
          this.text = error
          Swal.fire('Ocorreu um erro ao tentar efectuar a operação.','','error')
        }
      }
    },

    showAlertSucess () {
      this.alert = true
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Fornecedor  registrado com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.nif = ''
      this.editedItem.tipoFornecedor = ''
      this.editedItem.morada = ''
      this.editedItem.telefone1 = ''
      this.editedItem.telefone2 = ''
      this.editedItem.email = ''
      this.editedItem.observacao = ''
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
